import React from "react";
import { SidebarFooter } from "@repo/ui/primitives/sidebar";
import { Button } from "@repo/ui/primitives/button";
import { Sun, Moon, PanelLeftClose, PanelLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { formatSgrcAppVersionLabel, resolveSgrcAppVersion } from "@/lib/app-version.js";

const FOOTER_ICON_BUTTON_CLASS =
"size-[var(--ds-density-icon-button-size-compact)] shrink-0 text-sidebar-foreground/70 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 focus-visible:ring-sidebar-ring motion-reduce:transition-none";

export function SidebarFooterSection({ isCollapsed, theme, toggleTheme, toggleSidebar }) {
  const { t } = useTranslation("sidebar");
  const versionLabel = formatSgrcAppVersionLabel(resolveSgrcAppVersion());

  return (
    <SidebarFooter
      className={cn(
"border-t border-sidebar-border bg-sidebar transition-colors duration-[var(--ds-motion-duration-fast)] motion-reduce:transition-none",
        isCollapsed ? "p-1" : "p-2",
      )}
    >
      <div
        className={cn(
"w-full min-h-[36px] items-center",
          isCollapsed
            ? "flex justify-center"
            : "grid grid-cols-[var(--ds-density-icon-button-size-compact)_minmax(0,1fr)_var(--ds-density-icon-button-size-compact)]",
        )}
      >
        {!isCollapsed && (
          <Button
            onClick={toggleTheme}
            variant="ghost"
            size="icon"
            className={FOOTER_ICON_BUTTON_CLASS}
            aria-label={t("footer.toggleThemeAria", { defaultValue: "Toggle Theme" })}
          >
            {theme === "dark" ? <Sun className="h-3.5 w-3.5" /> : <Moon className="h-3.5 w-3.5" />}
          </Button>
        )}

        {!isCollapsed && versionLabel ? (
          <span
            className="min-w-0 truncate px-1 text-center font-mono text-[10px] font-medium tabular-nums tracking-wide text-sidebar-foreground/50"
            title={t("footer.versionAria", { version: versionLabel, defaultValue: "Application version {{version}}" })}
            aria-label={t("footer.versionAria", { version: versionLabel, defaultValue: "Application version {{version}}" })}
          >
            {versionLabel}
          </span>
        ) : null}

        <Button
          onClick={toggleSidebar}
          variant="ghost"
          size="icon"
          className={cn(FOOTER_ICON_BUTTON_CLASS, !isCollapsed && !versionLabel && "col-start-3")}
          aria-label={isCollapsed ? t("footer.expandSidebarAria", { defaultValue: "Expand Sidebar" }) : t("footer.collapseSidebarAria", { defaultValue: "Collapse Sidebar" })}
        >
          {isCollapsed ? (
            <PanelLeft className="h-3.5 w-3.5" />
          ) : (
            <PanelLeftClose className="h-3.5 w-3.5" />
          )}
        </Button>
      </div>
    </SidebarFooter>
  );
}
